import { render, staticRenderFns } from "./history.vue?vue&type=template&id=06db4618&scoped=true&lang=html&"
import script from "./history.vue?vue&type=script&lang=js&"
export * from "./history.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06db4618",
  null
  
)

export default component.exports